import MaskedInput from 'react-text-mask';
import React from 'react';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

interface DefaultMaskOptions {
  id: string,
  type: string,
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void,
  value?: string,
  placeholder: string,
  inputmode?: string,
  prefix?: string,
  suffix?: string,
  includeThousandsSeparator?: boolean,
  thousandsSeparatorSymbol?: string,
  allowDecimal?: boolean,
  decimalSymbol?: string,
  decimalLimit?: number,
  integerLimit?: number,
  allowNegative?: boolean,
  allowLeadingZeroes?: boolean
}

const defaultMaskOptions = {
  inputmode: '',
  prefix: '$',
  suffix: '',
  includeThousandsSeparator: true,
  thousandsSeparatorSymbol: ',',
  allowDecimal: true,
  decimalSymbol: '.',
  decimalLimit: 2, // how many digits allowed after the decimal
  integerLimit: 15, // limit length of integer numbers
  allowNegative: true,
  allowLeadingZeroes: false,
};

const CurrencyInput = (inputProps: DefaultMaskOptions) => {
  const currencyMask = createNumberMask({
    ...defaultMaskOptions,
  });

  return <MaskedInput mask={currencyMask} {...inputProps} />;
};

export default CurrencyInput;
